export const DEFAULT_ITEMS_PER_PAGE = 4;
export const DEFAULT_PAGE_NUMBER = 1;
